import { Routes } from './interfaces';

export const routes: Routes = {
  ARM_OHRANA: '/security',
  ARM_ORDERING: '/ordering',
  ARM_SUPERUSER: '/security',
  ARM_KIOSK: '/kiosk',
  ARM_DIRECTOR: '/director',
  ARM_MANAGER: '/manager',
  ARM_TVPANEL: '/tvpanel',
  ARM_ADMINISTRATOR: '/globaladmin',
};
